import React from 'react';
import gcpLogo from '../images/sendgrid-google-new.png';
import Styles from './gcpLogo.module.scss';

const GcpLogo = () => (
  <div className={Styles['gcp-logo']}>
    <img className={Styles['gcp-logo--sg']} src="https://uiux.s3.amazonaws.com/logo/sg-twilio-lockup.svg" alt="sendgrid logo" />
    <img className={Styles['gcp-logo--gcp']} src={gcpLogo} alt="google cloud platform logo" />
  </div>
);

export default GcpLogo;
